import { Api } from '@/api/api';
import { ClientMergeRequest } from '@/api/requests/merge/client-merge-request';

export class MergeApi extends Api {

    public async mergeClientAsync(request: ClientMergeRequest): Promise<void> {
        await this.putAsync(`v1/merge`, request);
    }

    public async mergeCompleteAsync(clientId: string): Promise<void> {
        await this.putAsync(`v1/merge/${clientId}/complete`, null);
    }

    public constructor() {
        super();
    }
}
